import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ImportarIrcpService extends BaseService<any> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/projetos/importar-ircp';
  }

  uploadFile(id: number, file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('import_file', file, file?.name);

    return this.http.post<any>(this.baseUrl + '/file/' + id, formData);
  }

}
